import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { HEADER_DROPDOWN_MENU_ID, HEADER_HEIGHT, HEADER_LINK_STYLE, HEADER_LI_STYLE } from '../../../constants/layout';
import { ReactLink } from '../../../models/common';
import { Button } from '../../atoms/Button';

type DropdownMenuProps = {
  dropdownLinks: ReactLink[];
  onClick: () => void;
};

export const DropdownMenu = ({ dropdownLinks, onClick }: DropdownMenuProps) => {
  const location = useLocation();
  return (
    <Box
      id={HEADER_DROPDOWN_MENU_ID}
      sx={{
        zIndex: 999,
        position: 'absolute',
        top: HEADER_HEIGHT,
        left: 0,
        width: '100%',
        borderTopWidth: '1px',
        borderTopStyle: 'solid',
        borderTopColor: 'primary.main',
        backgroundColor: '#fff',
        boxShadow: '0 0 20px rgba(0,0,0,0.15)'
      }}
    >
      <Box
        component="ul"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'stretch',
          columnGap: '4rem',
          py: '1rem'
        }}
      >
        {dropdownLinks.map((dropdownLink) => {
          const isCurrentPage: boolean = Boolean(dropdownLink.to && location.pathname === dropdownLink.to);
          return (
            <Box
              component="li"
              key={dropdownLink.label}
              sx={{ ...HEADER_LI_STYLE({ isActive: isCurrentPage }), p: '1rem' }}
            >
              <Button
                to={dropdownLink.to}
                href={dropdownLink.href}
                onClick={onClick}
                disableRipple
                sx={{ ...HEADER_LINK_STYLE({ isActive: isCurrentPage }) }}
                {...(isCurrentPage && { 'aria-current': 'page' })}
              >
                {dropdownLink.label}
              </Button>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
